import { InvoiceStatusEnum, InvoiceViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { Table, Tag, useIsDeviceSize } from '@foradevelopment/fora-ui';
import { dateStringFormatter } from '@fora-monorepo/date-utils';
import { swedishNumberFormatter } from '@fora-monorepo/string-utils';

import { InvoicesDetail } from './InvoicesDetail';
import { getStatusColor, getStatusText, getTypeText } from '../../utils';
import { useTypedTranslation } from '../../../i18n/i18n';

type InvoicesListTableRowProps = {
  invoice: InvoiceViewModel;
  isInitiallyExpanded?: boolean;
};

export const InvoicesTableRow = ({ invoice, isInitiallyExpanded }: InvoicesListTableRowProps) => {
  const { t } = useTypedTranslation();
  const { isMobile, isTablet } = useIsDeviceSize();

  if (isMobile) {
    return (
      <Table.Row isInitiallyExpanded={isInitiallyExpanded}>
        <Table.Cell>{invoice.ocr}</Table.Cell>
        <Table.Cell textAlign={'right'}>
          {invoice.status && invoice.status !== InvoiceStatusEnum.NoStatus && (
            <Tag
              variant={getStatusColor(invoice.status)}
              hasWhiteOutline={true}
              text={getStatusText(invoice.status, t)}
            />
          )}
        </Table.Cell>
        <Table.ExpandedRowBodyWrapper key={'body'}>
          <InvoicesDetail {...invoice} />
        </Table.ExpandedRowBodyWrapper>
      </Table.Row>
    );
  } else if (isTablet) {
    return (
      <Table.Row isInitiallyExpanded={isInitiallyExpanded}>
        <Table.Cell>{invoice.ocr}</Table.Cell>
        <Table.Cell textAlign={'left'}>
          {invoice.status && invoice.status !== InvoiceStatusEnum.NoStatus && (
            <Tag
              variant={getStatusColor(invoice.status)}
              hasWhiteOutline={true}
              text={getStatusText(invoice.status, t)}
            />
          )}
        </Table.Cell>
        <Table.Cell>{dateStringFormatter(invoice.invoiceDate)}</Table.Cell>
        <Table.Cell textAlign={'right'}>
          {invoice.invoiceDueDate ? dateStringFormatter(invoice.invoiceDueDate) : '-'}
        </Table.Cell>
        <Table.ExpandedRowBodyWrapper key={'body'}>
          <InvoicesDetail {...invoice} />
        </Table.ExpandedRowBodyWrapper>
      </Table.Row>
    );
  } else {
    return (
      <Table.Row isInitiallyExpanded={isInitiallyExpanded}>
        <Table.Cell>{invoice.ocr}</Table.Cell>
        <Table.Cell textAlign={'left'}>
          {invoice.status && invoice.status !== InvoiceStatusEnum.NoStatus && (
            <Tag
              variant={getStatusColor(invoice.status)}
              hasWhiteOutline={true}
              text={getStatusText(invoice.status, t)}
            />
          )}
        </Table.Cell>
        <Table.Cell>{getTypeText(invoice.invoiceType, t)}</Table.Cell>
        <Table.Cell>{dateStringFormatter(invoice.invoiceDate)}</Table.Cell>
        <Table.Cell>{invoice.invoiceDueDate ? dateStringFormatter(invoice.invoiceDueDate) : '-'}</Table.Cell>
        <Table.Cell textAlign="right">{swedishNumberFormatter(invoice.amount) + ' kr'}</Table.Cell>
        <Table.ExpandedRowBodyWrapper key={'body'}>
          <InvoicesDetail {...invoice} />
        </Table.ExpandedRowBodyWrapper>
      </Table.Row>
    );
  }
};
